import React from 'react'
import { connect } from 'react-redux';
import styled from 'styled-components'
import Option from '../components/Option';
import { ExitButton } from '../styled-components/components'
import { toggleSettings } from '../actions'
const SettingsContainer = styled.div`
position:absolute;
top:0;
left:0;
width:100vw;
height:100vh;
z-index:10;
background:rgba(0,0,0,.9);
`

const SettingsContent = styled.div`
max-width:700px;
margin:0 auto;
display:block;
position:relative;
`

const Title = styled.h1`
text-align:center;
`

function getSettings(settings){
    var settingsLi = []
    settings.map((value, key) => settingsLi.push(<Option key={key} optionType="global" optionName={key} option={value} />))
    return settingsLi
}
const SettingsScreen = ({shouldShow, settings, dispatch}) => {
    if (shouldShow === "settings"){
        return <SettingsContainer>
            <SettingsContent>
                <Title>Global Settings</Title>
                <ExitButton onClick={() => dispatch(toggleSettings({screen:"default"}))}/>
                <ul>
                    {getSettings(settings)}
                </ul>
            </SettingsContent>
        </SettingsContainer>
    }
    return null
}

function mapStateToProps(state){

    return({
        shouldShow : state.screen.screen,
        settings : state.settings,
        presetColors : state.presetSettings
    })
}
export default connect(mapStateToProps)(SettingsScreen)